var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"starry_background"},[_c('div',{attrs:{"id":"stars"}}),_c('div',{attrs:{"id":"stars2"}}),_c('div',{attrs:{"id":"stars3"}})])}]

export { render, staticRenderFns }